import { RootState } from '@/shared/store'
import { createSelector, EntityId } from '@reduxjs/toolkit'

import { ordersAdapter } from './ordersAdapters'

export const ordersSelectors = ordersAdapter.getSelectors<RootState>(
  (state) => state.orders,
)

export const selectOrdersByIds = createSelector(
  [ordersSelectors.selectEntities, (_, ids: EntityId[]) => ids],
  (orders, ids) => ids?.map(id => orders[id])?.filter(order => order != null) || [],
)
